<mat-card appearance="outlined" class="marginContent">
    <div class="mat-elevation-z0">
        <div>
            <form fxLayout="column wrap" fxLayoutAlign="space-between center" fxFlex="100" fxFlex.gt-sm="100"
                [formGroup]="form" (submit)="closeModal()">
                <h1 class="title">
                    Executar Programa
                </h1>

                <div style="width: 75%">
                    <idba-lookup-autocomplete class="generic-autocomplete"
                        formControlName="programa" [config]="programaLookup" />
                </div>

                <button type="submit" mat-raised-button color="action">
                    Executar
                </button>
            </form>
        </div>
    </div>
</mat-card>
